import apiClient, { withDefaultError } from "@/lib/apiClient";
import type { ApiResponse } from "@/types/api";
import type { AdminNotificationFeed, AdminNotificationsSeen } from "@/types/notifications";

// Dernières notifications de la cloche, les plus récentes d'abord.
export const getAdminNotifications = async (
  limit = 20
): Promise<ApiResponse<AdminNotificationFeed>> => {
  const response = await apiClient.get<AdminNotificationFeed>(
    `/admin/notifications?limit=${limit}`
  );
  return withDefaultError(response, "Échec du chargement des notifications");
};

// Marque vues, pour cet admin, les notifications jusqu'à la plus récente affichée.
export const markAdminNotificationsSeen = async (
  upTo: string
): Promise<ApiResponse<AdminNotificationsSeen>> => {
  const response = await apiClient.post<AdminNotificationsSeen>(
    "/admin/notifications/seen",
    { body: { upTo } }
  );
  return withDefaultError(response, "Échec de la mise à jour des notifications");
};
